// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IFileRecordErrorAggregatorDto
 */
export interface IFileRecordErrorAggregatorDto {
    /**
     * 
     * @type {number}
     * @memberof IFileRecordErrorAggregatorDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IFileRecordErrorAggregatorDto
     */
    file_record_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IFileRecordErrorAggregatorDto
     */
    file_record_error_type?: IFileRecordErrorAggregatorDtoFileRecordErrorTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IFileRecordErrorAggregatorDto
     */
    field_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IFileRecordErrorAggregatorDto
     */
    error_details?: string;
    /**
     * 
     * @type {string}
     * @memberof IFileRecordErrorAggregatorDto
     */
    error_code?: string;
    /**
     * 
     * @type {number}
     * @memberof IFileRecordErrorAggregatorDto
     */
    line_number?: number;
    /**
     * 
     * @type {string}
     * @memberof IFileRecordErrorAggregatorDto
     */
    partner_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IFileRecordErrorAggregatorDto
     */
    employer_id?: string;
    /**
     * 
     * @type {number}
     * @memberof IFileRecordErrorAggregatorDto
     */
    employee_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IFileRecordErrorAggregatorDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IFileRecordErrorAggregatorDto
     */
    last_name?: string;
}

/**
* @export
* @enum {string}
*/
export enum IFileRecordErrorAggregatorDtoFileRecordErrorTypeEnum {
    PARSING_ERROR = 'PARSING_ERROR',
    VALIDATION_ERROR = 'VALIDATION_ERROR',
    PROCESSING_ERROR = 'PROCESSING_ERROR',
    DESERIALIZATION_ERROR = 'DESERIALIZATION_ERROR'
}


/**
 * Check if a given object implements the IFileRecordErrorAggregatorDto interface.
 */
export function instanceOfIFileRecordErrorAggregatorDto(value: object): value is IFileRecordErrorAggregatorDto {
    return true;
}

export function IFileRecordErrorAggregatorDtoFromJSON(json: any): IFileRecordErrorAggregatorDto {
    return IFileRecordErrorAggregatorDtoFromJSONTyped(json, false);
}

export function IFileRecordErrorAggregatorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFileRecordErrorAggregatorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'file_record_id': json['file_record_id'] == null ? undefined : json['file_record_id'],
        'file_record_error_type': json['file_record_error_type'] == null ? undefined : json['file_record_error_type'],
        'field_name': json['field_name'] == null ? undefined : json['field_name'],
        'error_details': json['error_details'] == null ? undefined : json['error_details'],
        'error_code': json['error_code'] == null ? undefined : json['error_code'],
        'line_number': json['line_number'] == null ? undefined : json['line_number'],
        'partner_id': json['partner_id'] == null ? undefined : json['partner_id'],
        'employer_id': json['employer_id'] == null ? undefined : json['employer_id'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
    };
}

export function IFileRecordErrorAggregatorDtoToJSON(json: any): IFileRecordErrorAggregatorDto {
    return IFileRecordErrorAggregatorDtoToJSONTyped(json, false);
}

export function IFileRecordErrorAggregatorDtoToJSONTyped(value?: IFileRecordErrorAggregatorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'file_record_id': value['file_record_id'],
        'file_record_error_type': value['file_record_error_type'],
        'field_name': value['field_name'],
        'error_details': value['error_details'],
        'error_code': value['error_code'],
        'line_number': value['line_number'],
        'partner_id': value['partner_id'],
        'employer_id': value['employer_id'],
        'employee_id': value['employee_id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
    };
}

